import React from "react";
import Settings from "../components/Settings";

function SettingsPage() {
  return (
    <>
      <div>
        <Settings />
      </div>
    </>
  );
}

export default SettingsPage;
